(function () {
  'use strict';

  /* Don't show if: already subscribed, shown in last 3 days, or on checkout */
  var KEY_SHOWN    = 'snsei_popup_shown';
  var KEY_SUBSCRIBED = 'snsei_popup_sub';
  var COOLDOWN     = 3 * 24 * 60 * 60 * 1000; // 3 days

  // הטופס אמיתי ({% form 'customer' %}) ולכן שופיפיי מחזירה לדף עם ?customer_posted=.
  // פופאפ הכניסה כבר מציג את אישור ההצטרפות, אז כאן רק מסמנים ויוצאים, שני
  // אוברליים פתוחים בו-זמנית זה באג ולא אישור כפול.
  if (window.location.search.indexOf('customer_posted=') !== -1) {
    localStorage.setItem(KEY_SUBSCRIBED, '1');
    return;
  }
  if (localStorage.getItem(KEY_SUBSCRIBED)) return;
  var lastShown = parseInt(localStorage.getItem(KEY_SHOWN) || '0');
  if (Date.now() - lastShown < COOLDOWN) return;
  if (window.location.pathname.indexOf('/checkout') !== -1) return;
  if (window.location.pathname.indexOf('/cart') !== -1) return;

  // ⛔️ 19/08, לא על תנועה ממומנת ולא בעמודי הפנייה.
  // התפקיד של העמודים האלה הוא פנייה בוואטסאפ, לא נרשם לניוזלטר, ותנועה
  // שמשלמים עליה לא צריכה להיקטע באמצע. מזהה הקליק נשמר ל-session כי הוא
  // קיים רק בכתובת הנחיתה ונעלם בניווט הבא.
  var ENQUIRY_PAGES = ['/pages/corporate-gifts', '/pages/riach-laasakim'];
  if (ENQUIRY_PAGES.indexOf(window.location.pathname) !== -1) return;
  try {
    if (/[?&](fbclid|gclid|ttclid|msclkid)=/.test(window.location.search)) {
      sessionStorage.setItem('snsei_paid_visit', '1');
    }
    if (sessionStorage.getItem('snsei_paid_visit') === '1') return;
  } catch (e) {}

  var shown = false;

  function buildPopup() {
    // ⚠️ הסימון עצמו מגיע מ-snippets/sensei-floating.liquid ולא מכאן. הזרקת HTML מ-JS
    // הייתה מחייבת POST ידני ל-/contact, ו-Cloudflare חוסמת אותו ב-403 שקט, כלומר
    // הרשמות נבלעו. ראה reference_sensei_newsletter_signup_never_captured.
    var overlay = document.getElementById('snsei-exit-overlay');
    if (!overlay) return;

    var style = document.createElement('style');
    style.textContent = [
      '#snsei-exit-overlay{position:fixed;inset:0;background:rgba(0,0,0,0.72);z-index:99990;display:none;align-items:center;justify-content:center;padding:20px;opacity:0;pointer-events:none;transition:opacity 0.4s cubic-bezier(0.16,1,0.3,1);backdrop-filter:blur(6px);}',
      '#snsei-exit-overlay.visible{opacity:1;}',
      '#snsei-exit-box{background:#0c0c0c;max-width:480px;width:100%;padding:48px 40px 40px;position:relative;text-align:center;transform:translateY(20px);transition:transform 0.4s cubic-bezier(0.16,1,0.3,1);direction:rtl;}',
      '#snsei-exit-overlay.visible #snsei-exit-box{transform:none;}',
      '#snsei-exit-close{position:absolute;top:16px;left:16px;background:none;border:none;color:rgba(255,255,255,0.3);cursor:pointer;padding:8px;font-size:1.1rem;transition:color 0.2s;line-height:1;}',
      '#snsei-exit-close:hover{color:rgba(255,255,255,0.7);}',
      '.snsei-exit__line{width:32px;height:1px;background:rgba(201,169,110,0.4);margin:0 auto 24px;}',
      '.snsei-exit__tag{display:block;font-size:0.58rem;letter-spacing:0.34em;text-transform:uppercase;color:rgba(201,169,110,0.65);margin-bottom:16px;font-family:sans-serif;}',
      '.snsei-exit__title{font-family:"Cormorant Garant",Georgia,serif;font-weight:200;font-size:clamp(1.8rem,4vw,2.6rem);color:#fff;margin:0 0 10px;line-height:1.15;letter-spacing:0.03em;}',
      '.snsei-exit__title em{color:#C9A96E;font-style:normal;}',
      '.snsei-exit__sub{color:rgba(255,255,255,0.38);font-size:0.88rem;margin:0 0 32px;line-height:1.7;font-family:sans-serif;}',
      '.snsei-exit__form{display:flex;gap:8px;direction:rtl;}',
      '.snsei-exit__input{flex:1;background:rgba(255,255,255,0.07);border:1px solid rgba(255,255,255,0.12);color:#fff;padding:12px 16px;font-size:0.88rem;font-family:sans-serif;outline:none;}',
      '.snsei-exit__input::placeholder{color:rgba(255,255,255,0.28);}',
      '.snsei-exit__input:focus{border-color:rgba(201,169,110,0.4);}',
      '.snsei-exit__submit{background:rgba(201,169,110,0.15);color:#C9A96E;border:1px solid rgba(201,169,110,0.4);padding:12px 24px;font-size:0.7rem;letter-spacing:0.2em;text-transform:uppercase;cursor:pointer;font-family:sans-serif;white-space:nowrap;transition:background 0.2s;}',
      '.snsei-exit__submit:hover{background:rgba(201,169,110,0.25);}',
      '.snsei-exit__skip{display:block;margin-top:20px;color:rgba(255,255,255,0.2);font-size:0.68rem;letter-spacing:0.14em;cursor:pointer;background:none;border:none;font-family:sans-serif;transition:color 0.2s;}',
      '.snsei-exit__skip:hover{color:rgba(255,255,255,0.5);}',
      '.snsei-exit__error{color:#c48b8b;font-size:0.8rem;margin:10px 0 0;font-family:sans-serif;}',
      '@media(max-width:500px){#snsei-exit-box{padding:36px 24px 28px;}.snsei-exit__form{flex-direction:column;}}',
    ].join('');
    document.head.appendChild(style);

    function showPopup() {
      if (shown) return;
      shown = true;
      localStorage.setItem(KEY_SHOWN, Date.now().toString());
      overlay.style.display = 'flex';
      overlay.style.pointerEvents = 'auto';
      requestAnimationFrame(function() {
        requestAnimationFrame(function() { overlay.classList.add('visible'); });
      });
    }

    function hidePopup() {
      overlay.classList.remove('visible');
      overlay.style.pointerEvents = 'none';
      setTimeout(function() { overlay.style.display = 'none'; }, 400);
    }

    var closeBtn = document.getElementById('snsei-exit-close');
    var skipBtn = document.getElementById('snsei-exit-skip');
    closeBtn && closeBtn.addEventListener('click', hidePopup);
    skipBtn && skipBtn.addEventListener('click', hidePopup);
    overlay.addEventListener('click', function(e) { if (e.target === overlay) hidePopup(); });

    // Desktop: exit intent on mouse leave to top
    document.addEventListener('mouseleave', function(e) {
      if (e.clientY <= 5) showPopup();
    });

    // ⛔️ 19/08, טיימר 40 השניות במובייל הוסר, הכרעת מוטי.
    // במובייל אין סמן ולכן אין exit intent אמיתי; טיימר הוא כניסה מושהית
    // ולא יציאה, והוא כיסה את כפתור הוואטסאפ. במובייל נשאר רק אות
    // ההתנהגות שלמטה: גלילה חזרה לראש העמוד.

    // אות היציאה: מי שירד לעומק וחזר לראש העמוד.
    // 🪤 הגרסה הקודמת השוותה מול המיקום של אירוע הגלילה הקודם בלבד
    // (`lastScrollY > 400`). בגלילה טבעית, כשמגיעים מתחת ל-100 הערך הקודם
    // הוא כ-200, ולכן התנאי כמעט לעולם לא התקיים ורק קפיצה חדה הפעילה אותו.
    // כאן נשמר העומק המרבי שהמבקר הגיע אליו, וזה עובד גם בגלילה רציפה.
    var maxY = 0;
    window.addEventListener('scroll', function() {
      var sy = window.scrollY;
      if (sy > maxY) maxY = sy;
      if (!shown && maxY > 600 && sy < 120) showPopup();
    }, { passive: true });
  }

  // Delay initialization by 3s after page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(buildPopup, 3000); });
  } else {
    setTimeout(buildPopup, 3000);
  }
})();
